import {GrowthBook} from '@growthbook/growthbook-react';
import Analytics from 'utils/Analytics';
import {devLog} from 'utils/devLog';
import Identity from 'utils/Identity';
import Environment from './Environment';

export const setupGrowthbook = async () => {
  const anonId = Identity.ensureAnonymousID();
  await growthBook.setAttributes({web_funnel_anon_id: anonId});
  await growthBook.init();
  Analytics.track('Growthbook initialized', {
    anonId,
  });

  // Set the ID attribute on the GrowthBook instance.
  // NOTE: We use the `web_funnel_anon_id` attribute for all experiments

  Analytics.onReady(() => {
    Analytics.segment.user().then(user => {
      growthBook.updateAttributes({id: user.anonymousId()});
      devLog('GrowthBook set attr: id', growthBook.getAttributes().id);
    });
  });
};

export const growthBook = new GrowthBook({
  apiHost: 'https://cdn.growthbook.io',
  clientKey: process.env.REACT_APP_GB_KEY,
  enableDevMode: !Environment.isProduction,
  trackingCallback: (experiment, result) => {
    devLog('Growthbook trackingCallback', experiment, result);
    Analytics.track('temp_growthbook_experiment', {
      experimentId: experiment.key ?? 'N/A',
      experimentValue: result.value ?? 'N/A',
      variationId: result.key ?? 'N/A',
      variantName: result.name ?? 'N/A',
      inExperiment: result?.inExperiment ?? 'N/A',
      resultValue: result?.value ?? 'N/A',
      gbEnvironment: Environment.isProduction ? 'production' : 'development',
      growthBookReady: growthBook.ready ?? 'N/A',
      bucket: result?.bucket ?? 'N/A',
      hashUsed: result?.hashUsed ?? 'N/A',
      hashValue: result?.hashValue ?? 'N/A',
      surface: 'web-funnel',
    });
  },
  onFeatureUsage(featureKey, result) {
    devLog('Growthbook onFeatureUsage', featureKey, result);
    Analytics.track('temp_growthbook_feature_used', {
      experimentId: featureKey,
      source: result.source,
      variationId: result?.experimentResult?.key ?? 'N/A',
      variantName: result.experimentResult?.name ?? 'N/A',
      inExperiment: result.experimentResult?.inExperiment ?? 'N/A',
      experimentValue: result.experimentResult?.value ?? 'N/A',
      resultValue: result.value ?? 'N/A',
      gbEnvironment: Environment.isProduction ? 'production' : 'development',
      growthBookReady: growthBook.ready ?? 'N/A',
      surface: 'web-funnel',
    });
  },
});
